// import JS files
import '../kickstart';
import { h, render } from 'preact';

// Components
import App from '../Ballot';

render(<App />, document.getElementById('app'));

if (process.env.NODE_ENV === 'development') {
  require('preact/debug');
}
